import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolderPencil = () => {
  return (
    <g>
      <path d="m1.05 1.001 4.743.016c.396.001.754.224.931.57l.052.12.839 2.301 1.087.001a.75.75 0 0 1 .1 1.493L8.7 5.51l-7.2-.008v7.998h13V9.046a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .743.649l.007.101v4.904c0 .541-.41.987-.936 1.044L14.95 15H1.05a1.05 1.05 0 0 1-1.044-.936L0 13.95v-8.9L.003 5H0V2.051c0-.45.284-.84.76-1l.135-.037L1.05 1zm12.815 1.19.084.074 1.827 1.827a.753.753 0 0 1 .073.98l-.073.085-5.222 5.183a.747.747 0 0 1-.276.174l-.106.03-2.277.45a.756.756 0 0 1-.9-.79l.013-.097.45-2.278a.748.748 0 0 1 .134-.301l.073-.084 5.223-5.184a.751.751 0 0 1 .977-.068zM11.602 5.66 8.889 8.353l-.188.947.95-.188 2.71-2.69-.76-.763zm1.816-1.803-.75.743.76.763.751-.745-.76-.76zM1.5 2.502v1.499l4.518.005-.544-1.491L1.5 2.502z" />
    </g>
  );
};

export default withIcon(IconFolderPencil);
